import http from './http.js';

export async function fetchPlan() {
  return http.get('/subscription/plan');
}

export async function fetchMySubscription() {
  return http.get('/subscription/mine');
}

export async function fetchAdminPlan() {
  return http.get('/admin/subscription-plan');
}

export async function updateAdminPlan(data) {
  return http.put('/admin/subscription-plan', data);
}

export default {
  fetchPlan,
  fetchMySubscription,
  fetchAdminPlan,
  updateAdminPlan,
};
